import clsx from 'clsx'
import {HeaderUserMenu, AdminUserAvatar} from '../../../partials'
import {useAdminMenuProfile} from '../../../../app/modules/auth/core/AdminAuth'

const itemClass = 'ms-1 ms-lg-3'

const Navbar = () => {
  const profile = useAdminMenuProfile()

  return (
    <div className='app-navbar flex-shrink-0'>
      {/*<div className={clsx('app-navbar-item align-items-stretch', itemClass)}>*/}
      {/*  <Search />*/}
      {/*</div>*/}

      {/*<div className={clsx('app-navbar-item', itemClass)}>*/}
      {/*  <div id='kt_activities_toggle' className={btnClass}>*/}
      {/*    <KTIcon iconName='chart-simple' className={btnIconClass} />*/}
      {/*  </div>*/}
      {/*</div>*/}

      {/*<div className={clsx('app-navbar-item', itemClass)}>*/}
      {/*  <div*/}
      {/*    data-kt-menu-trigger="{default: 'click'}"*/}
      {/*    data-kt-menu-attach='parent'*/}
      {/*    data-kt-menu-placement='bottom-end'*/}
      {/*    className={btnClass}*/}
      {/*  >*/}
      {/*    <KTIcon iconName='element-plus' className={btnIconClass} />*/}
      {/*  </div>*/}
      {/*  <HeaderNotificationsMenu />*/}
      {/*</div>*/}

      {/*<div className={clsx('app-navbar-item', itemClass)}>*/}
      {/*  <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>*/}
      {/*    <KTIcon iconName='message-text-2' className={btnIconClass} />*/}
      {/*    <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />*/}
      {/*  </div>*/}
      {/*</div>*/}

      {/*<div className={clsx('app-navbar-item', itemClass)}>*/}
      {/*  <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />*/}
      {/*</div>*/}

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx(
            'cursor-pointer d-flex flex-row align-items-center',
            'gap-2 gap-lg-3 rounded-pill border border-gray-200 bg-white shadow-sm',
            'py-1 ps-2 pe-2 ps-md-3 pe-md-2',
          )}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          role='button'
          tabIndex={0}
          aria-label='Open account menu'
          title={profile ? `${profile.displayName} · ${profile.roleLabel}` : 'Account'}
        >
          <div
            className='d-none d-md-flex flex-column align-items-end text-end min-w-0 flex-shrink-1 lh-sm pe-1'
            style={{maxWidth: 180}}
          >
            <span className='text-gray-900 fw-bold fs-7 text-truncate w-100'>
              {profile?.displayName ?? 'Admin'}
            </span>
            <span className='text-muted fs-8 fw-semibold text-truncate w-100'>
              {profile?.roleLabel ?? 'Admin'}
            </span>
          </div>
          <div className='d-flex align-items-center justify-content-center flex-shrink-0 p-1'>
            <AdminUserAvatar sizeClass='symbol-35px symbol-md-40px' labelClass='fs-7 fw-bold' />
          </div>
        </div>
        <HeaderUserMenu />
      </div>

      {/*{config.app?.header?.default?.menu?.display && (*/}
      {/*  <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>*/}
      {/*    <div*/}
      {/*      className='btn btn-icon btn-active-color-primary w-35px h-35px'*/}
      {/*      id='kt_app_header_menu_toggle'*/}
      {/*    >*/}
      {/*      /!*<KTIcon iconName='text-align-left' className={btnIconClass} />*!/*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*)}*/}
    </div>
  )
}

export {Navbar}
